import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import BundleWidgetEN from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_en_US';
import BundleWidgetFR from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_fr_CA';
import { Text } from 'components/ui';

const getText = localeUtils.getLocalisedDataFromResource(BundleWidgetEN, BundleWidgetFR);

const BundleHeader = ({ title }) => (
    <Text
        is='h2'
        fontWeight='bold'
        fontSize={['lg-bg', 'xl']}
        lineHeight='tight'
    >
        {title || getText('frequentlyBoughtTogether')}
    </Text>
);

export default wrapFunctionalComponent(BundleHeader, 'BundleHeader');
